<template>
    <div class="entry-content">
        <h2>Information</h2>
        <form @submit.prevent="handleFormSubmit">
            <input type="text" v-model="name" placeholder="Unit Name" maxlength="400" required>
            <input type="number" min="1" v-model="order" placeholder="Unit Order">
            <div class="form-footer-wrapper">
                <button type="button" class="cancel" @click.prevent="handleRedirect">Cancel</button>
                <input type="submit" class="save" value="Save" />
            </div>
        </form>
    </div>
</template>

<script>
import CheckApi from '@/api'

export default {
    name: 'AddLesson',
    data() {
		return {
            name: '',
            order: ''
        }
    },
    methods: {
        async handleFormSubmit() {
            await CheckApi.createUnitTemplate({name: this.name, lessonTemplateId: parseInt(this.$route.params.lessonTemplateId), orderNumber: this.order})
            this.$router.push(`/templates/${this.$route.params.courseTemplateId}/lessons/${this.$route.params.lessonTemplateId}/units?page=1`)
        },
        handleRedirect() {
            this.$router.go(-1)
        }
    }
}
</script>

<style lang="scss" scoped>
.form-footer-wrapper {
        display: flex;
        justify-content: flex-end;
    }

    .cancel {
        background-color: transparent;
        border: .0625em solid #141638;

        &:hover {
            color: #141638;
        }
    }

    .cancel,
    .save {
        width: 100px !important;
        height: 30px !important;
        border-radius: .75em !important;
        text-align: center !important;
        cursor: pointer;
    }

    .save {
        margin-left: 15px;
        background-color: #08ce97;
        border-style: none;
        color: #fff;
        border-radius: 0.75em;
        display: block !important;
        margin: 0 !important;
        margin-left: 15px !important;
        padding: 5px;
    }
</style>